import { Box } from '@mui/material';
import { Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingSpinner } from '../components/EquipmentForm/LoadingSpinner';
import { ErrorSnackbar } from '../components/EquipmentForm/ErrorSnackbar';
import { FormContainer } from '../components/EquipmentForm/FormContainer';
import { FormHeader } from '../components/EquipmentForm/FormHeader';
import { FormContent } from '../components/EquipmentForm/FormContent';
import { FormActions } from '../components/EquipmentForm/FormActions';
import { initialValues } from '../constants/equipmentConstants';
import { equipmentValidationSchema } from '../validations/equipmentValidationSchema';
import { useEquipment } from '../context/useEquipment';
import { useAuth } from '../../auth/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { equipmentService } from '../../../shared/services/equipments/equipmentsServices';

export function EquipmentFormPage() {
  const { id } = useParams();
  const auth = useAuth();
  const navigate = useNavigate();
  const { 
    loading, 
    error, 
    setError, 
    loadingRooms, 
    rooms, 
    createEquipment, 
    updateEquipment
  } = useEquipment();

  const mode = id ? 'edit' : 'create';
  const isAdmin = auth.user?.role === 'admin';

  const { data: equipmentData, isLoading: isLoadingEquipment } = useQuery({
    queryKey: ['equipment', id],
    queryFn: () => equipmentService.getById(id!).then(res => res.data),
    enabled: !!id
  });

  const handleSubmit = async (values: any) => {
    try {
      if (mode === 'create') {
        values.tenantId = auth.selectedTenant.id;
        await createEquipment(values);
        setError('Equipamento criado com sucesso!');
      } else {
        await updateEquipment(id!, values);
        setError('Equipamento atualizado com sucesso!');
      }
      setTimeout(() => {
        navigate('/equipments');
      }, 1500);
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Erro ao salvar equipamento');
    }
  };

  if (loading || isLoadingEquipment) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <ErrorSnackbar error={error} onClose={() => setError(null)} />
      
      <FormContainer>
        <Formik
          initialValues={mode === 'create' ? initialValues : equipmentData || initialValues}
          validationSchema={equipmentValidationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <FormHeader mode={mode} />
              
              <FormContent
                values={values}
                errors={errors}
                touched={touched}
                isSubmitting={isSubmitting}
                loadingRooms={loadingRooms}
                rooms={rooms}
                mode={mode}
                isAdmin={isAdmin}
                authUser={auth.user}
                setFieldValue={setFieldValue}
              />

              <FormActions
                isSubmitting={isSubmitting}
                mode={mode}
              />
            </form>
          )}
        </Formik>
      </FormContainer>
    </>
  );
} 